const req = require.context('./svg', false, /\.svg$/);
req.keys().forEach(req);
